// Configuração do Google OAuth
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID';

// Pega a string do .env
const teamString = process.env.REACT_APP_TEAM;

// Faz o parse do JSON
let team = {};
try {
  team = JSON.parse(teamString);
} catch (e) {
  console.error('Erro ao fazer parse do TEAM:', e, teamString);
}

// Junta os emails de Tech e ProductOwner, removendo duplicados
export const AUTHORIZED_EMAILS = Array.from(
  new Set([
    ...(team.Tech || []),
    ...(team.ProductOwner || [])
  ])
);

// Configurações do sistema de autenticação
export const AUTH_CONFIG = {
  // Tempo de expiração da sessão (em horas)
  sessionExpirationHours: 24,
  
  // Chave para armazenar dados do usuário no localStorage
  userStorageKey: 'user',
  
  // Configurações do Google OAuth
  googleOAuth: {
    clientId: GOOGLE_CLIENT_ID,
    scope: 'email profile',
    prompt: 'select_account'
  }
}; 